<div
  class="gd-form-password-v2">

  <!-- Input data -->
  <mat-form-field
    *ngIf="!viewOnly; else viewOnlyTemplate"
    appearance="outline">

    <!-- Place holder -->
    <mat-label>
      {{ placeholder | translate }}
    </mat-label>

    <!-- Left - Icon buttons -->
    <ng-container
      *ngIf="tooltipButton?.tooltip"
      matPrefix>
      <popper-content
        #popperContent>
        <div
          [innerHtml]="tooltipButton.tooltip | safeHtml">
        </div>
      </popper-content>
      <mat-icon
        tabindex="-1"
        [popper]="popperContent"
        popperTrigger="hover"
        popperApplyClass="gd-form-input-v2-tooltip"
        popperPreventOverflow="true"
        popperPositionFixed="true"
        popperAppendTo="body"
        (click)="$event.stopPropagation()">{{tooltipButton.icon}}</mat-icon>
    </ng-container>

    <!-- Input -->
    <input
      matInput
      [(ngModel)]="value"
      (blur)="onTouchItem()"
      [errorStateMatcher]="errMatcher"
      [disabled]="disabled"
      [required]="required"
      [type]="type"
      autocomplete="off">

    <!-- Right - Icon buttons -->
    <ng-container
      *ngFor="let iconB of suffixIconButtons"
      matSuffix>
      <span
        *ngIf="!iconB.visible || iconB.visible(this)"
        (click)="$event.stopPropagation()">
        <button
          tabindex="-1"
          type="button"
          mat-icon-button
          [matTooltip]="iconB.tooltip | translate"
          [disabled]="iconB.disabled && iconB.disabled(this)"
          (click)="iconB.clickAction ? iconB.clickAction(this) : undefined"><mat-icon>{{iconB.icon}}</mat-icon></button>
      </span>
    </ng-container>

    <!-- Show / Hide password -->
    <span
      matSuffix>
      <button
        type="button"
        tabindex="-1"
        mat-icon-button
        [matTooltip]="showHideButton.tooltip | translate"
        (click)="showHideButton.clickAction(this)"><mat-icon>{{showHideButton.icon}}</mat-icon></button>
    </span>

    <!-- Errors -->
    <mat-error
      *ngIf="control?.invalid && control?.touched">
      {{ getErrorMessages() }}
    </mat-error>

  </mat-form-field>

  <!-- View only -->
  <ng-template
    #viewOnlyTemplate>
    <div
      fxLayout="row" fxLayoutGap="1.6rem"
      class="gd-form-password-v2-viewonly">
      <!-- Label -->
      <div
        *ngIf="placeholder"
        class="gd-form-password-v2-viewonly-label">
        {{ placeholder | translate }}:
      </div>

      <!-- Value -->
      <div
        class="gd-form-password-v2-viewonly-value">
        {{value ? (type !== 'password' ? value : '***') : noValueLabel}}
      </div>

      <!-- Show / Hide password -->
      <span
        *ngIf="value"
        matSuffix>
        <button
          type="button"
          tabindex="-1"
          mat-icon-button
          [matTooltip]="showHideButton.tooltip | translate"
          (click)="showHideButton.clickAction(this)"><mat-icon>{{showHideButton.icon}}</mat-icon></button>
      </span>
    </div>
  </ng-template>

</div>
